export default {"src":"/_next/static/media/mental-health-icon.ef23d7d0.svg","height":500,"width":500};